import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonFunctionsService } from '../services/common-functions.service';
import { DataModelService } from '../services/data-model.service';
import { LogService } from '../services/log.service';
import {
  AccountingYearWorkHour,
  EventViewMode,
  IEvent,
  Properties,
  User,
} from './../services/definitions.service';
import {
  ThreadSafeService,
} from '../services/thread-safe-component-state.service';
import firebase from 'firebase/app';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css'],
  providers: [ThreadSafeService], // Provide the service here
})
export class EventsComponent implements OnInit {
  public allEvents: IEvent[] = [];
  public pastEvents: IEvent[] = [];
  public users: User[] = [];
  public accountingYear: AccountingYearWorkHour;
  public userOptions: User[];
  public enumViewMode = EventViewMode;
  private userData: User;
  public centerTextMyShifts: string = '';
  public centerTextDoneShifts: string = '';
  public centerTextShiftRegister: string = '';
  swipeCoord: [number, number];
  selectedTab: number;
  swipeTime: number;
  private debugModeOn: boolean = false;

  constructor(
    private dataModel: DataModelService,
    private common: CommonFunctionsService,
    private log: LogService,
    public dialog: MatDialog
  ) {
    // Assign the data to the data source for the table to render
    this.common.registerEventEmitterHandlerUserData(async (data: User) => {
      this.userData = data;
    });
  }

  ngOnInit(): void {
    this.loadEvents();
    this.loadAccountingYear();
    this.loadUsers();
  }


  //Load events
  public async loadEvents() {
    //to avoid hiding events that are in the current time, we go just one week back
    const oneWeekAgo = new Date(new Date());
    oneWeekAgo.setDate(new Date().getDate() - 7);
    const today = firebase.firestore.Timestamp.fromDate(oneWeekAgo);

    // load all events of this year
    var wpLoaded = await this.dataModel.getEventsWithSubData(false, false, true, true, true, Properties.Start, today, ">="); //Loads only events from this year
    if (!wpLoaded.result) {
      this.common.showErrorToast('Aktuelle Events konnten nicht geladen werden');
      this.log.error(wpLoaded.errorMessage);
    } else {
      this.allEvents = wpLoaded.data;

      if (this.allEvents.length == 0) {
        this.centerTextMyShifts = 'Bei keiner Schicht angemeldet';
        this.centerTextShiftRegister = 'Keine Schichten vorhanden';
      }
    }

    // Load all past events
    wpLoaded = await this.dataModel.getEventsWithSubData(false, false, true, true, true, Properties.End, today, "<=", false);
    if (!wpLoaded.result) {
      this.common.showErrorToast('Abgelaufene Events konnten nicht geladen werden');
      this.log.error(wpLoaded.errorMessage);
    } else {
      this.pastEvents = wpLoaded.data;

      if (this.pastEvents.length == 0) {
        this.centerTextDoneShifts = 'Keine abgeschlossenen Schichten';
      }
    }
  }

  //Raised when all sub components of a view have been loaded
  public eventViewLoaded(event: IEvent) {
    // console.log(`(EventComponent): sub comp. event view (view mode: ${EventViewMode[EventViewMode.Reader]}) loaded: `+ event.id);
  }

  private async loadUsers() {
    this.common.loadAllUsers(
      (res: boolean, allUsersData: User[], options: User[]) => {
        if (res) {
          this.users = allUsersData;
          this.userOptions = options;
        }
      },
      false,
      true
    );
  }

  //loads the current accounting year
  private loadAccountingYear() {
    this.dataModel.loadCurrentAccountingYear().then(
      (fulfilled) => {
        this.accountingYear = fulfilled.data;
      },
      (rejectMsg) => {
        this.common.showErrorToast(
          'Konnte Daten des Abrechnungsjahr nicht laden'
        );
        this.log.error(rejectMsg, EventsComponent.name);
      }
    );
  }

  //Handle swipe between tabs
  public swipe(e: TouchEvent, when: string): void {
    const coord: [number, number] = [
      e.changedTouches[0].clientX,
      e.changedTouches[0].clientY,
    ];
    const time = new Date().getTime();
    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction = [
        coord[0] - this.swipeCoord[0],
        coord[1] - this.swipeCoord[1],
      ];
      const duration = time - this.swipeTime;
      if (
        duration < 1000 && //
        Math.abs(direction[0]) > 30 && // Long enough
        Math.abs(direction[0]) > Math.abs(direction[1] * 3)
      ) {
        if (this.selectedTab == undefined) this.selectedTab = 0;

        // Horizontal enough
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        console.info(swipe);
        if (swipe === 'next') {
          const isFirst = this.selectedTab === 0;
          if (this.selectedTab <= 3) {
            this.selectedTab = isFirst ? 1 : this.selectedTab + 1;
          }
          console.log('Swipe left — INDEX: ' + this.selectedTab);
        } else if (swipe === 'previous') {
          const isLast = this.selectedTab === 4;
          if (this.selectedTab >= 1) {
            this.selectedTab = this.selectedTab - 1;
          }
          console.log('Swipe right — INDEX: ' + this.selectedTab);
        }
      }
    }
  }

  //show debug info about a single work package
  public showDebugInfo(event: IEvent, viewMode: EventViewMode) {
    if (!this.debugModeOn) {
      return '';
    }
    return `Overall visibility (${event.id}) (mode: ${viewMode}): ${this.common.showEventView(event, viewMode, this.userData)}`;
  }
}
